import {useState, useCallback} from 'react';
import {useEventListener} from './useEventListener';

export const useHover = () => {
    const [isHovering, setIsHovering] = useState(false);
    const [ref, setRef] = useState<HTMLElement>(null);

    const handleMouseOver = useCallback(() => setIsHovering(true), []);
    const handleMouseOut = useCallback(() => setIsHovering(false), []);

    useEventListener('mouseover', handleMouseOver, ref);
    useEventListener('mouseleave', handleMouseOut, ref);

    return {setRef, isHovering};
};
